import * as _ from 'lodash'

const state = {
	map: null,
	states: null,
	selected_state: null,
	area_codes: null,
	// selected_areas: [],
	// excluded_areas: [],
	polygons: {},
}

const getters = {
	map: state => { return state.map },
	states: state => { return state.states },
	selectedState: state => { return state.selected_state },
	areaCodes: state => { return state.area_codes },
	// selectedAreas: state => { return state.selected_areas },
	polygons: state => { return state.polygons },
}

const mutations = {
	setmap (state, map) {
		state.map = map
	},
	setStates (state, boundary) {
		state.states = boundary
	},
	setSelectedState (state, polygon) {
		state.selected_state = polygon
	},
	setAreaCodes (state, areacodes) {
		state.area_codes = areacodes
	},
	// removeFromSelectedAreas (state, index) {
	// 	state.selected_areas.splice(index, 1)
	// }
}

const actions = {
	// addAreaCode ({commit}, params) {
	// 	let area = {area_code: params.city.area_code, state: params.selectedstate}
	// 	commit('setSelectedAreas', area)
	// },
	// removeAreaCode ({commit, state}, params) {
	// 	var index = state.selected_areas.findIndex(area => { return area.area_code === params.area_code })
	// 	if (index > -1) {
	// 		commit('removeFromSelectedAreas', index)
	// 	}
	// },
	removePolygons ({state}) {
		_.forEach(state.polygons, function (polygon) {
			polygon.setMap(null)
			polygon = null;
		})
		console.log('here removing polygons', state.polygons);
		// state.polygons = {}
	},
	removeAreaCodes ({state}) {
		_.forEach(state.area_codes, function (area) {
			if(!area.mapLabel || !area.polygon)
				return
			area.mapLabel.close()
			area.polygon.setMap(null)
		})
		state.area_codes = {}
		state.selected_state = null
	}
	// addExclusionPolygon ({state}, params) {
	// 	console.log('name', params.state)
	// 	state.excluded_areas.push(params.state)
	// },
	// removeExclusionPolygon ({state}, params) {
	// 	console.log('index', params)
	// 	state.excluded_areas.splice(params.index, 1)
	// }
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js